import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import classNames from 'classnames';
import './mobileNavigation.module.scss';
import { Logo } from '../../../../../commonv2/components/navigation/LikesLogo';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { NavigationTrialButton, TrialButton } from '../TrialButton';
import { LoginButton } from '../NavigationLoginButton';
import { V3Routes } from '../../../../routes';

const HamburgerButton = ({ color, open, onClick, setRef }) => (
    <div styleName={classNames('hamburger-button-wrapper', { open: open })}>
        <div
            id="hamburger-button"
            styleName={classNames('hamburger-button', color, { open: open })}
            onClick={onClick}
            ref={setRef}
        >
            <span />
            <span />
            <span />
        </div>
    </div>
);

type Props = {
    children: any;
    background: 'white' | 'transparent';
    topUrl: { pathname: string; hash: string } | string;
    className: string;
};

@observer
export class MobileNavigation extends React.Component<Props> {
    @observable menuOpen = false;

    @action.bound
    toggleMenu() {
        this.menuOpen = !this.menuOpen;
    }

    render() {
        const { children, background, topUrl } = this.props;
        const color = background === 'transparent' ? 'white' : 'dark';
        return (
            <div styleName={classNames('mobile-header', background)}>
                <Logo
                    styleName={classNames('logo', background)}
                    onClick={() => GlobalStatesV3.routing.push(topUrl as any)}
                />
                <div styleName="buttons">
                    {background === 'white' && (
                        <>
                            <NavigationTrialButton styleName="reserve-button">
                                WEBで簡単！<br />無料体験はこちら
                            </NavigationTrialButton>
                        </>
                    )}
                    <HamburgerButton
                        color={this.menuOpen ? 'dark' : color}
                        open={this.menuOpen}
                        onClick={this.toggleMenu}
                        setRef={() => null}
                    />
                </div>
                <div styleName={classNames('sidebar-overlay', { open: this.menuOpen })} onClick={this.toggleMenu}>
                    <div styleName={classNames('sidebar', { open: this.menuOpen })}>
                        <div styleName="sidebar-bg" />
                        <div styleName="sidebar-inner">
                            {children}
                            <div styleName="sidebar-buttons">
                                <TrialButton bodyClassName="cta-button-body" styleName="cta-button">
                                    WEBで簡単！無料体験はこちら
                                </TrialButton>
                                <LoginButton
                                    withBorder={true}
                                    styleName="sidebar-login-button"
                                    onClick={() => GlobalStatesV3.routing.push(V3Routes.signIn())}
                                >
                                    ログイン
                                </LoginButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
